import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { AnalyticsTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const fetchOverviewLoading = (state) => {
  return {
    ...state,
    fetchOverviewRequestState: RequestState.LOADING,
  }
}

export const fetchOverviewSuccess = (state, { data }) => {
  return {
    ...state,
    fetchOverviewRequestState: RequestState.SUCCEEDED,
    overview: data,
  }
}
export const fetchOverviewFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOverviewRequestState: requestState,
  }
}

export const fetchAverageDurationLoading = (state) => {
  return {
    ...state,
    fetchAverageDurationRequestState: RequestState.LOADING,
  }
}

export const fetchAverageDurationSuccess = (state, { data }) => {
  return {
    ...state,
    fetchAverageDurationRequestState: RequestState.SUCCEEDED,
    averageDuration: data,
  }
}
export const fetchAverageDurationFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAverageDurationRequestState: requestState,
  }
}

export const fetchTransactionsStatisticsLoading = (state) => {
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: RequestState.LOADING,
  }
}

export const fetchTransactionsStatisticsSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: RequestState.SUCCEEDED,
    transactionsStatistics: data,
  }
}
export const fetchTransactionsStatisticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: requestState,
  }
}

export const fetchConnectorsStatusLoading = (state) => {
  return {
    ...state,
    fetchConnectorsStatusRequestState: RequestState.LOADING,
  }
}

export const fetchConnectorsStatusSuccess = (state, { data }) => {
  return {
    ...state,
    fetchConnectorsStatusRequestState: RequestState.SUCCEEDED,
    connectorsStatus: { data },
  }
}
export const fetchConnectorsStatusFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchConnectorsStatusRequestState: requestState,
  }
}

export const fetchPeakHourLoading = (state) => {
  return {
    ...state,
    fetchPeakHourRequestState: RequestState.LOADING,
  }
}

export const fetchPeakHourSuccess = (state, { data }) => {
  return {
    ...state,
    fetchPeakHourRequestState: RequestState.SUCCEEDED,
    peakHour: data,
  }
}
export const fetchPeakHourFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchPeakHourRequestState: requestState,
  }
}

export const fetchTopSitesLoading = (state) => {
  return {
    ...state,
    fetchTopSitesRequestState: RequestState.LOADING,
  }
}

export const fetchTopSitesSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopSitesRequestState: RequestState.SUCCEEDED,
    topSites: data,
  }
}
export const fetchTopSitesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopSitesRequestState: requestState,
  }
}

export const fetchTokensStatisticsLoading = (state) => {
  return {
    ...state,
    fetchTokensStatisticsRequestState: RequestState.LOADING,
  }
}

export const fetchTokensStatisticsSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTokensStatisticsRequestState: RequestState.SUCCEEDED,
    tokensStatistics: data,
  }
}
export const fetchTokensStatisticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTokensStatisticsRequestState: requestState,
  }
}

export const fetchRevenueTrendLoading = (state) => {
  return {
    ...state,
    fetchRevenueTrendRequestState: RequestState.LOADING,
  }
}

export const fetchRevenueTrendSuccess = (state, { data }) => {
  return {
    ...state,
    fetchRevenueTrendRequestState: RequestState.SUCCEEDED,
    revenueTrend: data,
  }
}
export const fetchRevenueTrendFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchRevenueTrendRequestState: requestState,
  }
}

export const fetchTokensActivityLoading = (state) => {
  return {
    ...state,
    fetchTokensActivityRequestState: RequestState.LOADING,
  }
}

export const fetchTokensActivitySuccess = (state, { data }) => {
  return {
    ...state,
    fetchTokensActivityRequestState: RequestState.SUCCEEDED,
    tokensActivity: { ...data },
  }
}
export const fetchTokensActivityFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTokensActivityRequestState: requestState,
  }
}

export const fetchTopCitiesLoading = (state) => {
  return {
    ...state,
    fetchTopCitiesRequestState: RequestState.LOADING,
  }
}

export const fetchTopCitiesSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopCitiesRequestState: RequestState.SUCCEEDED,
    topCities: data,
  }
}
export const fetchTopCitiesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopCitiesRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [AnalyticsTypes.FETCH_OVERVIEW_LOADING]: fetchOverviewLoading,
  [AnalyticsTypes.FETCH_OVERVIEW_SUCCESS]: fetchOverviewSuccess,
  [AnalyticsTypes.FETCH_OVERVIEW_FAIL]: fetchOverviewFail,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_LOADING]: fetchAverageDurationLoading,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_SUCCESS]: fetchAverageDurationSuccess,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_FAIL]: fetchAverageDurationFail,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_LOADING]:
    fetchTransactionsStatisticsLoading,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_SUCCESS]:
    fetchTransactionsStatisticsSuccess,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_FAIL]:
    fetchTransactionsStatisticsFail,
  [AnalyticsTypes.FETCH_CONNECTORS_STATUS_LOADING]:
    fetchConnectorsStatusLoading,
  [AnalyticsTypes.FETCH_CONNECTORS_STATUS_SUCCESS]:
    fetchConnectorsStatusSuccess,
  [AnalyticsTypes.FETCH_CONNECTORS_STATUS_FAIL]: fetchConnectorsStatusFail,
  [AnalyticsTypes.FETCH_PEAK_HOUR_LOADING]: fetchPeakHourLoading,
  [AnalyticsTypes.FETCH_PEAK_HOUR_SUCCESS]: fetchPeakHourSuccess,
  [AnalyticsTypes.FETCH_PEAK_HOUR_FAIL]: fetchPeakHourFail,
  [AnalyticsTypes.FETCH_TOP_SITES_LOADING]: fetchTopSitesLoading,
  [AnalyticsTypes.FETCH_TOP_SITES_SUCCESS]: fetchTopSitesSuccess,
  [AnalyticsTypes.FETCH_TOP_SITES_FAIL]: fetchTopSitesFail,
  [AnalyticsTypes.FETCH_TOKENS_STATISTICS_LOADING]:
    fetchTokensStatisticsLoading,
  [AnalyticsTypes.FETCH_TOKENS_STATISTICS_SUCCESS]:
    fetchTokensStatisticsSuccess,
  [AnalyticsTypes.FETCH_TOKENS_STATISTICS_FAIL]: fetchTokensStatisticsFail,
  [AnalyticsTypes.FETCH_REVENUE_TREND_LOADING]: fetchRevenueTrendLoading,
  [AnalyticsTypes.FETCH_REVENUE_TREND_SUCCESS]: fetchRevenueTrendSuccess,
  [AnalyticsTypes.FETCH_REVENUE_TREND_FAIL]: fetchRevenueTrendFail,

  [AnalyticsTypes.FETCH_TOKENS_ACTIVITY_LOADING]: fetchTokensActivityLoading,
  [AnalyticsTypes.FETCH_TOKENS_ACTIVITY_SUCCESS]: fetchTokensActivitySuccess,
  [AnalyticsTypes.FETCH_TOKENS_ACTIVITY_FAIL]: fetchTokensActivityFail,

  [AnalyticsTypes.FETCH_TOP_CITIES_LOADING]: fetchTopCitiesLoading,
  [AnalyticsTypes.FETCH_TOP_CITIES_SUCCESS]: fetchTopCitiesSuccess,
  [AnalyticsTypes.FETCH_TOP_CITIES_FAIL]: fetchTopCitiesFail,
})
